<template>
  <div class="index">
    <div class="main-wrap">
      <div>
        <div class="wrapper">
          <jm-crumbs/>
          <div class="table-agile-info">
            <div
              class="crm-toolbox-area"
              v-for="(item, index) in options"
              :key="index">
              <a target="_blank" :href="item.url" :title="`单击进入【${item.title}】应用模块`">
                <div class="left">
                  <img
                    :src="item.icon"
                    :alt="item.alt" >
                </div>
                <div class="right">
                  <h3>{{ item.title }}</h3>
                  <span>{{ item.span }}</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .crm-toolbox-area{
    /* width:470px; */
    width:350px;
    height:150px;
    padding:22px 0;
    margin:0 20px 20px 0;
    float:left;
    border:3px solid #fff;
    border-radius:6px;
    background-color:#fff;
    overflow:hidden;
    box-sizing:border-box
  }
  .crm-toolbox-area:hover{
    border:3px solid #bad4ff;
    background-color:  #e6f3fd;
  }
  .crm-toolbox-area .left{
    width:106px;
    height:100%;
    text-align:center;
    float:left;
  }
  .crm-toolbox-area .right{
    /* width:364px; */
    width:230px;
    height:100%;
    float:left;
    position:relative
  }
  .crm-toolbox-area .right h3{
    margin:6px 0 5px;
    font-size:18px;
    color:#444;
  }
  .crm-toolbox-area .right span{
    display:block;
    padding-right:20px;
    text-align:left;
    font-size:14px;
    color:#74777c
  }
  .crm-toolbox-area .right a{
    display:inline-block;
    width:128px;
    height:36px;
    line-height:34px;
    position:absolute;
    bottom:9px;
    left:0;
    text-align:center;
    background-color:#3368fa;
    color:#fff;
    -webkit-border-radius:3px;
    -moz-border-radius:3px;
    border-radius:3px;
  }
</style>
<script>
import crumbs from '@/components/tool/crumbs.vue';

export default {
  data() {
    return {
      options: null
    };
  },
  components: {
    'jm-crumbs': crumbs,
  },
  methods: {
    fetchData() {
      this.$http
        ._get({
          url: '/index/sales_tools/index'
        })
        .then(({ data }) => {
          data.forEach((item) => {
            // eslint-disable-next-line
            item.icon = require(`../../assets/toolbox/icon-${item.icon}.png`);
          });
          this.options = data;
        });
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>
